import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { catchError, map, of, tap } from 'rxjs';

import { AuthRestartService, BootstrapService } from 'app/shared/services';
import { AuthFacadeService } from 'app/shared/services/auth-facade.service';

/**
 * Bootstrap guard
 *
 * Responsibilities:
 * - Ensure the application bootstrap is executed once per session.
 * - If there is no valid access token, start OAuth authorization flow.
 * - Never calls /token directly from the guard.
 */
export const authBootstrapGuard: CanActivateFn = (route, state) => {
    const bootstrap = inject(BootstrapService);
    const authRestart = inject(AuthRestartService);
    const authFacade = inject(AuthFacadeService);

    if (bootstrap.isReady()) {
        return true;
    }

    bootstrap.markLoading();

    if (!authFacade.hasValidAccessToken()) {
        authRestart.restartAuthorization({
            notify: true,
            returnUrl: state.url,
        });
        return false;
    }

    return authFacade.bootstrap$()
        .pipe(
            tap(() => bootstrap.markReady()),
            map(() => true),
            catchError(() => {
                authRestart.restartAuthorization({
                    notify: true,
                    returnUrl: state.url,
                });
                return of(false);
            })
        );
};
